/* tslint:disable */
require('./FieldLookupRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_7a99db46',
  relative: 'relative_7a99db46',
  fabricIcon: 'fabricIcon_7a99db46',
  lookup: 'lookup_7a99db46',
};

export default styles;
/* tslint:enable */